import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from "moment";
import { ToastsManager } from 'ng2-toastr';
import { Observable, Subject } from 'rxjs';
import { SettingComponent } from '../../../components/setting/setting.component';
import { BaseComponent } from '../../../core/components';
import { SkadetypModel } from '../../../models/incidentAccidentModel';
import { AuthenticationService, IncidentAccidentServiceService, ModuleService, SiteService } from '../../../services';
import { DeviceHelper } from '../../../shared/helpers';
import { modalLarge, modalSmall } from '../../../shared/modules/dialogOptions';
import { IncidentAccidentListComponent } from '../../components/incident-accident-list/incident-accident-list.component';

@Component({
    selector: 'app-incident-accident',
    templateUrl: './incident-accident.component.html',
    styleUrls: ['./incident-accident.component.scss']
})
export class IncidentAccidentComponent extends BaseComponent implements OnInit {
    @ViewChild('incidentAccidentList') incidentAccidentList: IncidentAccidentListComponent;
    isAdminOrUserEditor: boolean;
    SiteId: number;
    user: any
    skadetyp: SkadetypModel = new SkadetypModel();
    //isImplementationOngoing = true;
    module: any;
    showAccidentType: boolean = false;
    isProcessing: boolean = false;
    typeData: number = 3;
    CurrentDate: NgbDateStruct;
    DateTo: NgbDateStruct;
    sites: any[] = [];
    accidentType: number = 0;
    skadetypes: any = [];
    datatoDelete: any;
    showSkadetypeFilters: boolean = false;
    searchText: string = '';
    skadetypesFilters: any[] = [];
    role: any[];
    isGenerating: boolean = false;
    status: any = 0;
    isMobile: boolean = false;
    constructor(private location: Location,
        public router: Router, private route: ActivatedRoute,
        private moduleService: ModuleService,
        private siteService: SiteService,
        private incidentAccidentService: IncidentAccidentServiceService,
        private toastr: ToastsManager,
        private authenticationService: AuthenticationService,
        private modalService: NgbModal) {

        super(router);
    }

    ngOnInit() {
        window.scroll(0, 0);

        localStorage.setItem('typeData', '3');
        localStorage.setItem('status', '2');

        localStorage.setItem('currentModuleId', '30');
        if (DeviceHelper.isMobile()) {
            this.isMobile = true;
        }

        var dateOld = new Date('1998-01-01');
        var dateNow = new Date();

        this.CurrentDate = <NgbDateStruct>
            {
                year: dateOld.getFullYear(),
                month: dateOld.getMonth() + 1,
                day: dateOld.getDate()
            };

        this.DateTo = <NgbDateStruct>
            {
                year: dateNow.getFullYear(),
                month: dateNow.getMonth() + 1,
                day: dateNow.getDate()
            };

        this.loadRole();
        this.Initialize();

        this.customInput.debounceTime(1400).distinctUntilChanged().subscribe(value => {
            this.reLoad();
        });

    }

    loadRole() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        var moduleId = 30;
        this.authenticationService.getRoleByModule(currentUser.id, moduleId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.role = response.Data;
                this.incidentAccidentList.role = response.Data;
            });
    }

    reInitializeDropdowns() {
        if (this.typeData == 0 || this.typeData == 3) {
            this.accidentType = 0;
            this.showSkadetypeFilters = false;
            //this.reLoad();
        } else if (this.typeData == 1 || this.typeData == 2) {

            this.accidentType = 0;
            this.loadSkadetypesFilters();

        }
    }

    customInput: Subject<string> = new Subject();

    inputValueChanged(event) {

        this.customInput.next(event);
    }

    ExportXLS(): void {
        this.isGenerating = true;
        var modelData = {
            Date: this.CurrentDate.year + "-" + this.CurrentDate.month + "-" + this.CurrentDate.day,
            SiteId: this.SiteId,
            Status: this.status,
            Date1: this.DateTo.year + "-" + this.DateTo.month + "-" + this.DateTo.day,
            Type: this.typeData,
            Search: this.searchText,
            AccountId: this.user.accountId,
            UserId: this.user.id,
            AccidentType: this.accidentType
        };

        this.incidentAccidentService.ExportXLSList(modelData)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {

                this.isGenerating = false;

                const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                const url = window.URL.createObjectURL(blob);

                var fileLink = document.createElement('a');
                fileLink.href = url;
                var currentD = new Date();

                fileLink.href = url;

                var d = moment(new Date()).format('YYYYMMDDHHmm');
                if (this.SiteId == 0) {
                    fileLink.download = `ser_incidents_accidents_allobjects_${d}` + ".xlsx";
                } else {
                    // var siteName = this.sites.filter(x => x.Id == this.SiteId)[0].Name
                    var objectname = this.sites.filter(x => x.Id == this.SiteId)[0].Name;
                    objectname = objectname.replace(/\s+/g, '').toLowerCase();


                    fileLink.download = `ser_incidents_accidents_${objectname}_${d}` + ".xlsx";
                }

                fileLink.click();
            });
    }


    downloadPDF() {
        this.isGenerating = true;
        var modelData = {
            Date: this.CurrentDate,
            SiteId: this.SiteId,
            Date2: this.DateTo
        };

        //this.CurrentDate,this.DateTo,this.accidentType,this.SiteId, this.typeData, this.searchText, this.status

        this.incidentAccidentService.DownloadReportList(modelData.Date.year + "-" + modelData.Date.month + "-" + modelData.Date.day, modelData.SiteId, modelData.Date2.year + "-" + modelData.Date2.month + "-" + modelData.Date2.day)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response) => {

                const blob = new Blob([response], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url);
                this.isGenerating = false;
            });

    }

    saveSkadetyp() {
        this.isProcessing = true;

        let currentUser = super.currentLoggedUser();
        this.skadetyp.AccountId = currentUser.accountId;

        this.incidentAccidentService.saveSkadetype(this.skadetyp)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.isProcessing = false;
                var prev = this.skadetyp.Type;
                this.skadetyp = new SkadetypModel();
                this.skadetyp.Type = prev;
                this.loadSkadetypes();
            });

    }

    public openType(type: string): void {
        this.modalService.open(type, modalLarge);
    }

    loadSkadetypes() {

        if (this.skadetyp.Type != undefined && this.skadetyp.Type != 0) {
            let currentUser = super.currentLoggedUser();
            this.incidentAccidentService.GetSkadetypes(this.skadetyp.Type, currentUser.accountId)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.skadetypes = response.Data;
                    //this.skadetypesLoading = false;
                });
        }

    }

    loadSkadetypesFilters() {

        if (this.typeData != undefined && this.typeData != 0) {
            let currentUser = super.currentLoggedUser();
            this.incidentAccidentService.GetSkadetypes(this.typeData, currentUser.accountId)
                .catch((err: any) => {
                    return Observable.throw(err);
                })
                .finally(() => {
                    setTimeout(() => {

                    }, 1000);
                })
                .subscribe((response: any) => {
                    this.skadetypesFilters = response.Data;
                    this.showSkadetypeFilters = true;
                    //this.reLoad();
                    //this.skadetypesLoading = false;
                });
        }

    }

    Initialize() {
        this.getLocalStorageFilters();

        if (localStorage.getItem('IncidentAccidentcurrentSiteId') != null) {
            this.SiteId = +localStorage.getItem('IncidentAccidentcurrentSiteId');

        }

        let currentUser = super.currentLoggedUser();
        this.user = JSON.parse(localStorage.getItem('currentUser'));
        var SiteId = +localStorage.getItem('IncidentAccidentcurrentSiteId');

        this.moduleService.getModuleByTitle("Incident Accident")
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((resp: any) => {

                this.module = resp.Data;

                this.siteService.getByAccountIdAndUserId(currentUser.accountId, this.user.id, this.module.Id)
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {

                        }, 1000);
                    })
                    .subscribe((response: any) => {
                        this.sites = response.Data;
                        this.sites.unshift({ Id: 0, Name: 'All Objects' });
                        if (SiteId == null || SiteId == 0) {
                            this.SiteId = this.sites[0].Id;
                            localStorage.setItem('IncidentAccidentcurrentSiteId', this.SiteId.toString());
                            localStorage.setItem('currentSiteId', this.SiteId.toString());
                        }
                        this.incidentAccidentList.loadDataById(this.CurrentDate, this.DateTo, this.accidentType, this.SiteId, this.typeData, this.searchText, this.status);
                    });

            });


    }

    enableAdding() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        var role = this.role.find(x => x.SiteId === this.SiteId);
        if (this.SiteId && this.SiteId > 0 && this.sites.filter(x => x.Id == this.SiteId).length > 0 && ((role && role.RoleId != 3) || currentUser.role.toLowerCase() === 'admin')) return true;
        return false;
    }

    public openSettingsModal(): void {
        //var data = new Type3Component();
        localStorage.setItem('currentModuleId', '30');
        const modalRef = this.modalService.open(SettingComponent, modalLarge);
        modalRef.componentInstance.SiteIdFromModal = this.SiteId;

        modalRef.result.then((result) => {
            this.ngOnInit();

        }, (reason) => {
            this.ngOnInit();
            // alert(reason +"aaa");
        });
    }
    public navigateToPublicPage(type: string): void {

        this.router.navigate([], { relativeTo: this.route }).then(result => { window.open(`/#/incident-accident/` + this.SiteId + `/create`, '_blank'); });

    }

    getLocalStorageFilters() {


        if (localStorage.getItem('AccountId') != null) {
            var accountId = +localStorage.getItem('AccountId');
            let currentUser = super.currentLoggedUser();
            if (accountId == currentUser.accountId) {
                if (localStorage.getItem('CurrentDate') != null) {
                    // this.CurrentDate = new Date(localStorage.getItem('CurrentDate'));

                    var from = new Date(localStorage.getItem('CurrentDate'));

                    this.CurrentDate = <NgbDateStruct>
                        {
                            year: from.getFullYear(),
                            month: from.getMonth() + 1,
                            day: from.getDate()
                        };
                }

                if (localStorage.getItem('DateTo') != null) {
                    // this.CurrentDate = new Date(localStorage.getItem('CurrentDate'));

                    var to = new Date(localStorage.getItem('DateTo'));

                    this.DateTo = <NgbDateStruct>
                        {
                            year: to.getFullYear(),
                            month: to.getMonth() + 1,
                            day: to.getDate()
                        };
                }

                if (localStorage.getItem('typeData') != null) {
                    this.typeData = +localStorage.getItem('typeData');
                    this.reInitializeDropdowns();
                    //alert(this.SiteId);
                }

                if (localStorage.getItem('accidentType') != null) {
                    this.accidentType = +localStorage.getItem('accidentType');
                    //alert(this.SiteId);
                }

                if (localStorage.getItem('status') != null) {
                    this.status = +localStorage.getItem('status');
                    //alert(this.SiteId);
                }

            }

        }
    }

    reLoad() {
        let currentUser = super.currentLoggedUser();
        //    this.skadetyp.AccountId = currentUser.accountId;

        localStorage.setItem('IncidentAccidentcurrentSiteId', this.SiteId.toString());
        localStorage.setItem('currentSiteId', this.SiteId.toString());
        localStorage.setItem('AccountId', currentUser.accountId.toString());

        ///localStorage.setItem('CurrentDate', this.SiteId.toString());
        localStorage.setItem('CurrentDate', new Date(this.CurrentDate.year, this.CurrentDate.month - 1, this.CurrentDate.day).toString());
        localStorage.setItem('DateTo', new Date(this.DateTo.year, this.DateTo.month - 1, this.DateTo.day).toString());

        localStorage.setItem('typeData', this.typeData.toString());
        localStorage.setItem('accidentType', this.accidentType.toString());
        localStorage.setItem('status', this.status.toString());



        setTimeout(() => {
            this.incidentAccidentList.loadDataById(this.CurrentDate, this.DateTo, this.accidentType, this.SiteId, this.typeData, this.searchText, this.status);

        }, 1000);
        //this.Initialize();

        //this.loadIncidents();
    };

    openDelete(settingsContent: string, data: any = null) {

        this.datatoDelete = data;

        this.modalService.open(settingsContent, modalSmall);
    }

    deleteData() {
        this.incidentAccidentService.DeleteSkadetyp(this.datatoDelete)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                if (!response.Success) {
                    this.toastr.error("Data is currently used.", "Error");
                }
                this.loadSkadetypes();
            });
    }

    getSkadeType(id: number) {
        this.incidentAccidentService.GetSkadetype(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {

                this.skadetyp = response.Data;
            });
    }

    get isAdmin() {
        var role = JSON.parse(localStorage.getItem("currentUser"))?.role ?? ""
        return role == 'admin'
    }

    checkEndDate() {
        const end = new Date(`${this.DateTo.year}-${this.DateTo.month}-${this.DateTo.day}`)
        const start = new Date(`${this.CurrentDate.year}-${this.CurrentDate.month}-${this.CurrentDate.day}`)

        if (end < start) {
            this.DateTo = this.CurrentDate
        }
    }

    checkStartDate() {
        const end = new Date(`${this.DateTo.year}-${this.DateTo.month}-${this.DateTo.day}`)
        const start = new Date(`${this.CurrentDate.year}-${this.CurrentDate.month}-${this.CurrentDate.day}`)

        if (start > end) {
            this.CurrentDate = this.DateTo
        }
    }

    get maxDate() {
        var date = new Date()
        return <NgbDateStruct>
            {
                year: date.getFullYear(),
                month: date.getMonth() + 1,
                day: date.getDate()
            };
    }

    get minDate() {
        var date = new Date()
        return <NgbDateStruct>
            {
                year: date.getFullYear() - 10,
                month: 1,
                day: 1
            };
    }

}



// WEBPACK FOOTER //
// ./src/app/incident-accident/pages/index/incident-accident.component.ts